import React from 'react';
import style from 'assets/jss/material-dashboard-pro-react/views/contactUs/queriesAndComplaintsStyle';
import { makeStyles } from '@material-ui/core';
import { BodyM, BodyMBold } from 'components/Typography/Typography';
import classNames from 'classnames';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';

// @ts-ignore
const useStyles = makeStyles(style);

interface ISingleTabButtonProps {
	icon: React.ReactElement;
	text: string;
	onClick: () => void;
	active: boolean;
}

const SingleTabButton = ({ icon, text, onClick, active }: ISingleTabButtonProps) => {
	const classes = useStyles();

	return (
		<div
			className={classNames(classes.singleTabButtonWrapper, { [classes.singleTabButtonActiveWrapper]: active })}
			onClick={onClick}
		>
			<div className={classes.singleTabButtonIconWrapper}>{icon}</div>
			<ConditionalRender
				show={active}
				onTrue={() => (
					<BodyMBold color="enterprise" disableMargin>
						{text}
					</BodyMBold>
				)}
				onFalse={() => (
					<BodyM color="primary-light" disableMargin>
						{text}
					</BodyM>
				)}
			/>
		</div>
	);
};

export default SingleTabButton;
